import { fishIdentityMarkup, resolveFishGrade } from "../components/fish-identity.js";
import { escapeHtml } from "./presentation.js";

export function itemGroupMembersMarkup(
  members,
  itemLookup,
  {
    direct = false,
    wrapperAttribute = "",
  } = {},
) {
  return `
    <span
      class="inline-flex min-w-0 items-center gap-1.5"
      ${wrapperAttribute}
    >
      ${members.map((member, index) => `
        ${index > 0 ? '<span class="text-base-content/45" aria-hidden="true">·</span>' : ""}
        <span
          class="inline-flex min-w-0"
          data-item-id="${escapeHtml(member.itemId)}"
          ${direct ? 'data-item-group-direct-item="true"' : ""}
        >
          ${fishIdentityMarkup(member, itemLookup)}
        </span>
      `).join("")}
    </span>
  `;
}

export function itemGroupAppliedMarkup(
  presentation,
  itemLookup = null,
  { groupLabelMarkup = "", interactiveLabel = false } = {},
) {
  if (presentation?.nameGroup) return presentation.nameGroup.contentMarkup;
  const members = Array.isArray(presentation?.directMembers)
    ? presentation.directMembers
    : [];
  if (!members.length) {
    return groupLabelMarkup;
  }
  const directMarkup = itemGroupMembersMarkup(members, itemLookup, {
    direct: true,
    wrapperAttribute: 'data-item-group-direct-members="true"',
  });
  const identity = presentation?.identity;
  if (!groupLabelMarkup && (!presentation?.isSpecial || !identity)) {
    return directMarkup;
  }
  return `
    <span class="relative inline-flex min-w-0 items-center" data-item-group-applied="true">
      ${directMarkup}
      <span
        class="absolute left-0 top-full mt-1 flex w-full flex-col items-center text-[0.9rem]"
        ${interactiveLabel ? "" : 'aria-hidden="true"'}
        data-item-group-special-connector="true"
        data-item-group-special="${escapeHtml(presentation.itemIds.join(","))}"
      >
        <span class="h-px w-full bg-base-content/25" aria-hidden="true"></span>
        <span class="h-1.5 w-px bg-base-content/25" aria-hidden="true"></span>
        <span
          class="inline-flex min-w-max items-center"
          data-item-group-special-identity="true"
          ${!groupLabelMarkup ? `data-item-group-identity-item-id="${escapeHtml(identity.itemId)}"` : ""}
        >
          ${groupLabelMarkup || fishIdentityMarkup(identity, itemLookup, { truncateLabel: false })}
        </span>
      </span>
    </span>
  `;
}

export function itemNameGroupView(members, t) {
  const representative = members.reduce((first, member) => member.itemId < first.itemId ? member : first);
  const label = t("map.search.item_group.any", { label: representative.name });
  const grade = sharedItemGroupGrade(members, resolveFishGrade) || "white";
  const identity = { ...representative, name: label, grade, isPrize: grade === "red" };
  return {
    label,
    grade,
    contentMarkup: `<span class="inline-flex min-w-0 items-center" data-item-name-group>${fishIdentityMarkup(identity, null, { truncateLabel: false })}</span>`,
  };
}

export function sharedItemGroupGrade(members, resolveGrade) {
  const grades = new Set(members.map(member => resolveGrade(member)));
  return grades.size === 1 ? [...grades][0] : "";
}
